import { Model } from '@vuex-orm/core';

class Category extends Model {
  static entity = 'categories';

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      icon: this.attr(null),
      taskTypes: this.attr(null),
      recommendedTask: this.attr(null),
      children: this.attr([]),
    };
  }

  static apiConfig = {
    actions: {
      fetchByGroupName(name) {
        return this.get(`groups/${name}/categories`);
      },
    },
  }
}

export default Category;
